import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TramiteStatus } from './tramite-status.model';

@Injectable({
  providedIn: 'root'
})
export class TramiteStatusService {
  url: string;
  endpoint = 'estados'

  constructor(
    private http: HttpClient
  ) { }

  getTramiteStatus(): Observable<TramiteStatus[]> {
    return this.http.get<TramiteStatus[]>(`${this.url}/${this.endpoint}/`);
  }
}
